export const PERSIST_DATA = "persist";
export const CUSTOMER_ID = "customer_id";
export const CONTRACTOR_ID = "contractor_id";
export const CREATE_ANOTHER = "create_another_warranty";
export const COPY_WARRANTY_DATA = "copy_warranty_data";
export const SEARCH_ITEM = "search_item";
export const DRAFT_WARRANTY_SELECTED = "draft_warranty_selected";
export const WARRANTY_ERROR_CHECK = "draft_warranty_error_check";
export const IS_EDITABLE_WARRANTY = "is_editable_warranty";